import './topbar.scss';


export default function Topbar({ menuOpen, setMenuOpen }) {
    return (
        <div className={'topbar ' + (menuOpen && 'active') }>
            <div className="wrapper">

                <div className="left">
                    <a href="/" className='logo'>
                        <img src="assets/img/logo.png" alt=""/>
                    </a>
                </div>

                <div className='center'>
                    <div className="itemContainer">
                        <a href="#servicios"> SERVICIOS</a>
                        <a href="#nosotros"> ¿QUIENES SOMOS?</a>
                        <a href="#instrumental"> INSTRUMENTAL</a>
                        <a href="#contacto"> CONTACTO</a>
                    </div>
                </div>

                <div className="right">

                    <div className="options" onClick={() => setMenuOpen(!menuOpen)}>
                        <span className='line1'></span>
                        <span className='line2'></span>
                        <span className='line3'></span>
                    </div>
                </div>
            </div>
        </div>
    )
}